var map = {
	"./mAdminC.webp": 7116,
	"./mBio.webp": 4546,
	"./mContY.jpg": 5065,
	"./mContaT.webp": 6769,
	"./mDerecho.webp": 5262,
	"./mDerechoC.webp": 8483,
	"./mDerechoY.jpg": 2089,
	"./mEnfermeria.webp": 4754,
	"./mEnfermeriaC.webp": 2991,
	"./mEnfermeriaT.webp": 6610,
	"./mFisio.webp": 5018,
	"./mFisioC.webp": 9927,
	"./mFisioT.webp": 2586,
	"./mIngCY.jpg": 1592,
	"./mMedicina.webp": 3572,
	"./mMedicinaC.webp": 5505,
	"./mMedicinaT.webp": 3560,
	"./mOdonto.webp": 1451,
	"./mOdontoT.webp": 9305,
	"./mSist.webp": 3316
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2635;